module.exports = __webpack_public_path__ + "static/media/page3_sama2.fd450138.wav";